/**
 * Organism: listing-stars — chargement AJAX des étoiles sur pages de liste produits.
 *
 * Collecte tous les .df-reviews-listing-stars de la page, appelle
 * l'endpoint en batch et injecte les notes.
 */

import { create as createStars } from '../atoms/star-rating';

interface GradeEntry {
  avg:   number;
  count: number;
}

export async function init(): Promise<void> {
  const placeholders = Array.from(
    document.querySelectorAll<HTMLElement>('.df-reviews-listing-stars[data-flt-reviews-id]')
  );

  if (!placeholders.length) return;

  const gradeUrl = placeholders[0].dataset.fltReviewsUrl ?? '';
  if (!gradeUrl) return;

  const ids = placeholders.map(p => p.dataset.fltReviewsId ?? '').filter(Boolean);

  try {
    const url = new URL(gradeUrl);
    url.searchParams.set('ids', ids.join(','));

    const res   = await fetch(url.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });
    const data  = await res.json() as Record<string, GradeEntry>;

    placeholders.forEach((el) => {
      const id    = el.dataset.fltReviewsId ?? '';
      const entry = data[id];
      if (!entry) return;

      const gradeEl = el.querySelector<HTMLElement>('.df-reviews-listing-grade');
      const countEl = el.querySelector<HTMLElement>('.df-reviews-listing-count');

      if (gradeEl) {
        gradeEl.innerHTML = '';
        gradeEl.appendChild(createStars(Math.round(entry.avg), 'xs'));
      }
      if (countEl) {
        countEl.textContent = `(${entry.count})`;
      }

      el.setAttribute('aria-label', `${entry.avg.toFixed(1)} / 5 — ${entry.count} avis`);
    });
  } catch {
    // Silencieux — les placeholders restent vides
  }
}
